export default "__VITE_ASSET__6f61579b__"